<template>
  <div>
    <router-view></router-view>

    <loader-general />
  </div>
</template>

<script>

  import LoaderGeneral from "./Partials/Loader/General"

  export default {
    name: "App",
    components: {LoaderGeneral},
    metaInfo() {
      return {
        titleTemplate: '%s | TecknaEl Affiliate Kontrollpanel',
        link: [
          {
            rel: 'icon',
            type: 'image/x-icon',
            href: require('./../../img/favicon.ico')
          }
        ],
        htmlAttrs: {
          lang: 'sv'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue